export const BASE_BUTTON = 1;
export const WITH_CIRCLE_BUTTON = 2;
